import React from 'react';

const CERTS = ['ISO 9001', 'ISO 14001', 'FDA 21 CFR', 'REACH', 'RoHS', 'HALAL', 'EN 71-3', 'BPA-Free'];

export default function CertStrip({ className = '' }) {
  return (
    <div className={`cert-strip ${className}`.trim()} data-palette="cloud" aria-label="Certifications">
      {CERTS.map((cert) => (
        <span key={cert} className="cert-strip__item">
          {cert}
        </span>
      ))}
    </div>
  );
}
